import React from 'react';
import {classNames} from "../../../utils/common";

const AccountField = ({label, accountName, setAccountName, smallerSize = false}) => {
    return (
        <div className={classNames(smallerSize ? "mt-2 mx-3" : "mt-5 mx-8")}>
            <label htmlFor="accountName" className={classNames(
                smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                "block font-medium text-gray-700"
            )}>{label}</label>
            <div className={classNames(
                smallerSize ? "mt-0.5 h-7" : "mt-1 h-10",
                "relative rounded-md shadow-sm"
            )}>
                <input
                    value={accountName}
                    onChange={(event) => setAccountName(event.target.value)}
                    type="text"
                    id="accountName"
                    className={classNames(
                        smallerSize
                            ? "h-7 w-44 px-2 text-xs"
                            : "h-10 w-60 px-4 sm:text-sm",
                        "focus:ring-indigo-500 focus:border-indigo-500 block border-gray-300 rounded-md"
                    )}
                />
            </div>
        </div>
    );
};

export default AccountField;
